module.exports = new __parcel__URL__("epic_pack_icon.907efc45.png").toString();